/**
 * cypAdhdModuleConfig.js — the CYP ADHD patient overview's stage layout.
 *
 * Fixed four-stage layout (no optional Behavioural Observation stage), so
 * unlike adult autism there is nothing workflow-derived to resolve.
 *
 * Four distinct blocks with the adult-equivalent names (decision, 21 Aug):
 * CI and SSI happen in one appointment but are separate blocks. The branch's
 * original combined "Developmental Diagnostic Interview" card was a copy of
 * the autism three-block layout and is deliberately gone.
 *
 * WHY THIS IS ITS OWN MODULE. Both the overview page and its loading skeleton
 * need the stage count, and the skeleton must not import the page to get it —
 * the page pulls in Layout, TopNavBar and Firebase, so the skeleton rendered
 * while the page is still loading would drag that whole tree in with it. One
 * small config module both can import keeps the count in a single place
 * without that coupling, which is what stops the skeleton laying out a
 * different number of cards from the page (the autism skeleton's bug).
 */
export const CYP_ADHD_MODULE_CONFIG = {
  moduleOrder: [
    'clinicalInterview',
    'semiStructuredInterview',
    'diagnosticDecision',
    'postAssessmentDiscussion',
  ],
  modules: {
    clinicalInterview: {
      title: 'Clinical Interview',
      circleNumber: 1,
    },
    semiStructuredInterview: {
      title: 'Semi-Structured Interview',
      circleNumber: 2,
    },
    diagnosticDecision: {
      title: 'Diagnostic Decision',
      circleNumber: 3,
    },
    postAssessmentDiscussion: {
      title: 'Post-Assessment Discussion',
      circleNumber: 4,
    },
  },
};

export default CYP_ADHD_MODULE_CONFIG;
